// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"58955c5ccebbe17126d7","655":"26f84453b49365bca172"}[chunkId] + ".js";
};